import { useEffect, useState, useCallback } from "react"
import { Link, useNavigate } from "react-router-dom";
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { CHAVE_TOKEN, real, dataBR, hojeISO, linkWhatsApp } from "../../../utils/formata";

const rotuloStatus = { analise: "Em análise", ativo: "Ativo" };

export default function VisitaAgenda() {
    const [visitas, setVisitas] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [editando, setEditando] = useState(null); // { id, data, hora, endereco }
    const [salvando, setSalvando] = useState(false);
    const { consultarAgendaVisitas, marcarVisita, desmarcarVisita } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    const carregar = useCallback(() => {
        setCarregando(true);
        consultarAgendaVisitas()
            .then((data) => setVisitas(data || []))
            .catch((error) => setErroPadrao(error))
            .finally(() => setCarregando(false));
    }, [consultarAgendaVisitas, setErroPadrao]);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        carregar();
    }, [carregar, navigate]);

    const hoje = hojeISO();
    const comVisita = visitas.filter((v) => v.visitaData);
    const deHoje = comVisita.filter((v) => v.visitaData === hoje);
    const futuras = comVisita.filter((v) => v.visitaData > hoje);
    const passadas = comVisita.filter((v) => v.visitaData < hoje);
    const semVisita = visitas.filter((v) => !v.visitaData);

    function abrirEdicao(v) {
        setEditando({
            id: v.id,
            data: v.visitaData || hoje,
            hora: v.visitaHora || "14:00",
            endereco: v.visitaEndereco || v.Empresa?.endereco || "",
            nome: v.Empresa?.nomeFantasia || v.Empresa?.razaoSocial,
            remarcando: !!v.visitaData,
        });
    }

    function handleSalvar(e) {
        e.preventDefault();
        setSalvando(true);
        marcarVisita(editando.id, { endereco: editando.endereco, data: editando.data, hora: editando.hora })
            .then(() => { setEditando(null); carregar(); })
            .catch((error) => setErroPadrao(error))
            .finally(() => setSalvando(false));
    }

    function handleDesmarcar(v) {
        const nome = v.Empresa?.nomeFantasia || v.Empresa?.razaoSocial;
        if (!window.confirm(`Desmarcar a visita de ${nome} (${dataBR(v.visitaData)} às ${v.visitaHora})?\n\nO cliente recebe um aviso no WhatsApp e a proposta continua ativa.`)) return;
        desmarcarVisita(v.id).then(carregar).catch((error) => setErroPadrao(error));
    }

    function Cartao({ v, destaque }) {
        const empresa = v.Empresa || {};
        const nome = empresa.nomeFantasia || empresa.razaoSocial;
        return (
            <div className="he-card" style={{marginBottom: "0.8em", borderLeft: destaque ? "3px solid #d4af37" : undefined}}>
                <div style={{display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12}}>
                    <div style={{flex: "1 1 260px", minWidth: 0, overflowWrap: "break-word"}}>
                        <div style={{display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap"}}>
                            {v.visitaData &&
                                <span className="he-dourado" style={{fontWeight: 700, fontSize: "1.05em"}}>
                                    <i className="bi bi-calendar-event"></i> {dataBR(v.visitaData)} às {v.visitaHora}
                                </span>
                            }
                            <span className={`badge badge-${v.status}`}>{rotuloStatus[v.status] || v.status}</span>
                        </div>
                        <div style={{fontWeight: 700, marginTop: 4, fontSize: "1.02em"}}>{nome}</div>
                        <div style={{fontSize: "0.85em", color: "#9aa5b5", lineHeight: 1.5}}>
                            {empresa.responsavel} · {real(v.valorPrincipal)} em {v.numParcelas}x de {real(v.valorParcela)}
                        </div>
                        {v.visitaEndereco && <div style={{fontSize: "0.85em", marginTop: 4, lineHeight: 1.5}}><i className="bi bi-geo-alt he-dourado"></i> {v.visitaEndereco}</div>}
                    </div>
                    <div className="acoes-linha" style={{alignItems: "flex-start"}}>
                        {empresa.telefone &&
                            <a className="btn btn-sm btn-success" title="WhatsApp" target="_blank" rel="noreferrer"
                               href={linkWhatsApp(empresa.telefone, `Olá ${empresa.responsavel}! Aqui é da Help Empresarial 😊`)}>
                                <i className="bi bi-whatsapp"></i><span className="so-mobile-inline"> WhatsApp</span>
                            </a>
                        }
                        {v.visitaEndereco &&
                            <a className="btn btn-sm btn-outline-he" title="Abrir no mapa" target="_blank" rel="noreferrer"
                               href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(v.visitaEndereco)}`}>
                                <i className="bi bi-map"></i><span className="so-mobile-inline"> Mapa</span>
                            </a>
                        }
                        <button className="btn btn-sm btn-outline-he" onClick={() => abrirEdicao(v)}>
                            <i className="bi bi-calendar-plus"></i> {v.visitaData ? "Reagendar" : "Marcar"}
                        </button>
                        {v.visitaData &&
                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDesmarcar(v)}>
                                <i className="bi bi-calendar-x"></i> Desmarcar
                            </button>
                        }
                        <Link className="btn btn-sm btn-he largura-total" to={`/emprestimo/${v.id}`}>Abrir</Link>
                    </div>
                </div>
            </div>
        );
    }

    function Secao({ titulo, icone, lista, destaque, vazio }) {
        return (
            <div style={{marginBottom: "1.8em"}}>
                <h5 className="he-titulo he-dourado" style={{marginBottom: "0.6em"}}><i className={icone}></i> {titulo} ({lista.length})</h5>
                {lista.length === 0
                    ? <p style={{color: "#9aa5b5", fontSize: "0.9em"}}>{vazio}</p>
                    : lista.map((v) => <Cartao key={v.id} v={v} destaque={destaque}/>)
                }
            </div>
        );
    }

    return (
        <div className="pagina">
            <h2 className="he-titulo">Agenda de <span className="he-dourado">Visitas</span></h2>
            <p style={{color: "#9aa5b5", fontSize: "0.9em"}}>
                Toda alteração aqui avisa o cliente no WhatsApp automaticamente 💬
            </p>

            {editando &&
                <form onSubmit={handleSalvar} className="he-card form-mobile" style={{border: "1px solid #d4af37", margin: "1em 0"}}>
                    <h5 className="he-titulo he-dourado" style={{marginBottom: "0.7em", overflowWrap: "break-word"}}>
                        <i className="bi bi-calendar-plus"></i> {editando.remarcando ? "Reagendar" : "Marcar"} visita — {editando.nome}
                    </h5>
                    <div className="row">
                        <div className="col-md-3 campo-form">
                            <label className="form-label" style={{fontSize: "0.8em"}}>Data</label>
                            <input className="form-control form-control-sm" type="date" value={editando.data} onChange={(e) => setEditando({...editando, data: e.target.value})} required/>
                        </div>
                        <div className="col-md-2 campo-form">
                            <label className="form-label" style={{fontSize: "0.8em"}}>Hora</label>
                            <input className="form-control form-control-sm" type="time" value={editando.hora} onChange={(e) => setEditando({...editando, hora: e.target.value})} required/>
                        </div>
                        <div className="col-md-5 campo-form">
                            <label className="form-label" style={{fontSize: "0.8em"}}>Endereço do estabelecimento</label>
                            <input className="form-control form-control-sm" value={editando.endereco} onChange={(e) => setEditando({...editando, endereco: e.target.value})} required/>
                        </div>
                        <div className="col-md-2 campo-form" style={{display: "flex", alignItems: "flex-end"}}>
                            <div className="acoes-linha" style={{width: "100%"}}>
                                <button type="submit" className="btn btn-sm btn-he" style={{flex: 1}} disabled={salvando}>
                                    {salvando ? <span className="spinner-border spinner-border-sm"></span> : "Salvar"}
                                </button>
                                <button type="button" className="btn btn-sm btn-outline-he" onClick={() => setEditando(null)}>Fechar</button>
                            </div>
                        </div>
                    </div>
                </form>
            }

            {carregando
                ? <div style={{textAlign: "center", padding: "2em"}}><span className="spinner-border" style={{color: "#d4af37"}}></span></div>
                : <>
                    <Secao titulo="Hoje" icone="bi bi-calendar-check" lista={deHoje} destaque vazio="Nenhuma visita marcada para hoje."/>
                    <Secao titulo="Próximas" icone="bi bi-calendar-week" lista={futuras} vazio="Nenhuma visita futura agendada."/>
                    <Secao titulo="Aguardando agendamento" icone="bi bi-hourglass-split" lista={semVisita} vazio="Todos os contratos já têm visita marcada."/>
                    {passadas.length > 0 && <Secao titulo="Anteriores" icone="bi bi-clock-history" lista={passadas} vazio=""/>}
                </>
            }
        </div>
    )
}
